import { Client } from '../client/'
import qs from 'qs'
import Vue from 'vue'
class BasicCalls {
    constructor() {
        this.apiRoot = 'api'
        this.apiVersion = 'v1'
        this.apiBase = ''
        this._client = new Client()
    }

    get base() {
        return `${this.apiRoot}${this.apiVersion?.length ? `/${this.apiVersion}` : ''}${
            this.apiBase?.length ? `/${this.apiBase}` : ''
        }`
    }

    fetch(_url, _params) {
        return this.#basicCall(_url, _params, 'index')
    }
    store(_url, _params) {
        return this.#basicCall(_url, _params, 'store')
    }

    destroy(_url, _params) {
        return this.#basicCall(_url, _params, 'destroy')
    }

    #basicCall = async function (_url, _params, callType) {
        try {
            const params = qs.stringify(_params, {
                encode: true,
                arrayFormat: Vue.prototype.$arrayFormat,
            })
            const base = _url ? `${this.base?.length ? `${this.base}/` : ''}${_url}` : this.base
            let url = `${base}${params !== '' ? `?${params}` : ''}`
            window.debug.info(`Basic call, type '${callType}' from ${this.apiBase}\n ${url}`)
            const res = await this._client[callType](url)
            return Promise.resolve(res?.data || res)
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

export default BasicCalls
